module.exports = __webpack_public_path__ + "static/media/banner.c63fa35b.webp";